export default __webpack_public_path__ + "static/media/linkedin_logo.0fdb1fe5.webp";